import _ from 'lodash';
import { getMeasureValuesColumns } from '../../devextreme/model/pivot-data-model-utils';
import { ChartSpecificColumnType, } from '../../types';
import { getAllColumnsInAxisConfig, getChartType, getColumn, getColumns, } from '../chart-model-utils';
import { configOptions, isCustomOrTsHostedChart, } from '../chart-type-specification-service';
import { getName } from '../column-name-util';
const getMeasureNamesAndValuesConfig = (chartModel, chartConfigParameters) => {
    const chartType = getChartType(chartModel);
    if (isCustomOrTsHostedChart(chartType)) {
        return chartConfigParameters === null || chartConfigParameters === void 0 ? void 0 : chartConfigParameters.measureNameValueColumns;
    }
    return configOptions(chartModel.config.chartType, chartModel)
        .allowedConfigurations.measureNameValueColumns;
};
const isMeasureNamesEnabled = (chartModel, chartConfigParameters) => {
    var _a, _b;
    const chartType = getChartType(chartModel);
    if (isCustomOrTsHostedChart(chartType)) {
        return ((_b = (_a = chartConfigParameters === null || chartConfigParameters === void 0 ? void 0 : chartConfigParameters.measureNameValueColumns) === null || _a === void 0 ? void 0 : _a.enableMeasureNameColumn) !== null && _b !== void 0 ? _b : false);
    }
    return getMeasureNamesAndValuesConfig(chartModel, chartConfigParameters)
        .enableMeasureNameColumn;
};
const isMeasureValuesEnabled = (chartModel, chartConfigParameters) => {
    var _a, _b;
    const chartType = getChartType(chartModel);
    if (isCustomOrTsHostedChart(chartType)) {
        return ((_b = (_a = chartConfigParameters === null || chartConfigParameters === void 0 ? void 0 : chartConfigParameters.measureNameValueColumns) === null || _a === void 0 ? void 0 : _a.enableMeasureValueColumn) !== null && _b !== void 0 ? _b : false);
    }
    return getMeasureNamesAndValuesConfig(chartModel, chartConfigParameters)
        .enableMeasureValueColumn;
};
const isMeasureNameColumn = (column) => {
    return ((column === null || column === void 0 ? void 0 : column.chartSpecificColumnType) === ChartSpecificColumnType.MeasureNames);
};
const isMeasureValueColumn = (column) => {
    return ((column === null || column === void 0 ? void 0 : column.chartSpecificColumnType) ===
        ChartSpecificColumnType.MeasureValues);
};
const isMeasureNameOrValueColumn = (column) => {
    return isMeasureNameColumn(column) || isMeasureValueColumn(column);
};
const getOverrideNamesForChartSpecificColumns = (chartModel, chartConfigParameters) => {
    const mnvConfig = getMeasureNamesAndValuesConfig(chartModel, chartConfigParameters);
    return chartModel.columns.reduce((overrideNames, column) => {
        const output = _.cloneDeep(overrideNames);
        if (isMeasureNameColumn(column.column)) {
            output[column.column.id] = column.column.isUserDefinedTitle
                ? getName(column.column)
                : mnvConfig.measureNameColumnAlias;
        }
        if (isMeasureValueColumn(column.column)) {
            output[column.column.id] = column.column.isUserDefinedTitle
                ? getName(column.column)
                : mnvConfig.measureValueColumnAlias;
        }
        return output;
    }, {});
};
const filterMeasureColumnsByChart = (chartModel, chartConfigParameters, isMeasureNameValuesEnabled = true) => {
    const allColumns = getColumns(chartModel);
    return allColumns.filter(column => {
        const measureNameValueDisabled = !isMeasureNameValuesEnabled && isMeasureNameOrValueColumn(column);
        const measureNamesDisabled = !isMeasureNamesEnabled(chartModel, chartConfigParameters) &&
            isMeasureNameColumn(column);
        const measureValuesDisabled = !isMeasureValuesEnabled(chartModel, chartConfigParameters) &&
            isMeasureValueColumn(column);
        if (measureNameValueDisabled ||
            measureNamesDisabled ||
            measureValuesDisabled) {
            return false;
        }
        return true;
    });
};
const containsMeasureNamesOrMeasureValuesColumns = (visualAxisConfig) => {
    return getAllColumnsInAxisConfig(visualAxisConfig).some(column => {
        return [
            ChartSpecificColumnType.MeasureNames,
            ChartSpecificColumnType.MeasureValues,
        ].includes(column.chartSpecificColumnType);
    });
};
const findMeasureNameColumnIndex = (columns) => {
    return columns.findIndex(column => column.chartSpecificColumnType ===
        ChartSpecificColumnType.MeasureNames);
};
const getSageColumnsFromColumnId = (chartViz, columnId) => {
    if (_.isNil(columnId)) {
        return [];
    }
    const column = getColumn(chartViz, columnId);
    if (isMeasureNameOrValueColumn(column)) {
        return getMeasureValuesColumns(chartViz);
    }
    return _.compact([column]);
};
export { filterMeasureColumnsByChart, getOverrideNamesForChartSpecificColumns, containsMeasureNamesOrMeasureValuesColumns, isMeasureNameColumn, isMeasureValueColumn, isMeasureNameOrValueColumn, findMeasureNameColumnIndex, getSageColumnsFromColumnId, };
//# sourceMappingURL=index.js.map